import React from 'react';
import { Alert } from '@cof/gravity-react';
import { maintenanceBannerNotification } from '../../strings';

export const CurrentDowntimeBanner = ({ activeLanguage }) => {
  const message = maintenanceBannerNotification[activeLanguage].Message;

  return (
    <div className="downtime-banner" data-testid="currentdowntime-banner">
      <Alert
        type="warning"
        message={message}
      />
    </div>
  );
};
